import React from 'react';

const StarIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM12 22C6.485 22 2 17.514 2 12C2 6.486 6.485 2 12 2C17.515 2 22 6.486 22 12C22 17.514 17.515 22 12 22Z'
      fill='white'
    />
    <path
      d='M12 4C7.582 4 4 7.582 4 12C4 16.419 7.582 20 12 20C16.418 20 20 16.419 20 12C20 7.582 16.418 4 12 4ZM15.6125 15.7449C15.8109 16.2014 15.2932 16.6359 14.8781 16.3613L12.2758 14.6403C12.1086 14.5296 11.8914 14.5296 11.7242 14.6403L9.12238 16.361C8.7072 16.6356 8.1895 16.201 8.38806 15.7445L9.56048 13.0493C9.64862 12.8466 9.59331 12.6102 9.42445 12.4677L7.0453 10.4599C6.68908 10.1593 6.90166 9.57783 7.36776 9.57783H9.94653C10.151 9.57783 10.3348 9.45338 10.4107 9.26358L11.5358 6.45197C11.7034 6.03297 12.2966 6.03297 12.4642 6.45197L13.5893 9.26358C13.6652 9.45338 13.849 9.57783 14.0535 9.57783H16.6325C17.0986 9.57783 17.3112 10.1593 16.955 10.4599L14.5764 12.4677C14.4076 12.6102 14.3523 12.8466 14.4404 13.0492L15.6125 15.7449Z'
      fill='url(#paint0_linear)'
    />
    <defs>
      <linearGradient
        id='paint0_linear'
        x1='7'
        y1='6'
        x2='17'
        y2='18'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FF00E5' />
        <stop offset='1' stopColor='#FF9900' />
      </linearGradient>
    </defs>
  </svg>
);

export default StarIcon;
